import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';
import { FormControl } from 'react-bootstrap';
import { Form, Panel, Status } from 'axway-react-ui';
import Title from './Title';
import Property from './Property';
import Description from './Description';

class EndpointConfig extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render() {
		const { endpoint } = this.props;
		const summary = endpoint.summary;
		const index = summary.indexOf(' ');
		const verb = summary.substr(0, index);
		const path = summary.substr(index + 1);
		const { status } = endpoint;
		const state = (!status.valid) ? 'error'
			: endpoint.enabled ? 'enabled' : 'disabled';

		const title = (
			<Title
				name={summary}
				editable={false}
				icon="icon-GG-api"
				invalid={!status.valid}
			/>
		);

		return (
			<div className="nodeconfig">
				<Form horizontal className="nodeconfig-form">
					<Panel
						key="panel-node"
						header={title}
						className="panel-node"
					>
						<Property>
							<Property.Name>
								{this.intl.formatMsg('Trigger')}
							</Property.Name>
							<Property.Value>
								<FormControl.Static>
									{this.intl.formatMsg('Endpoint')}
								</FormControl.Static>
							</Property.Value>
						</Property>
						<Property>
							<Property.Name>
								{this.intl.formatMsg('Method')}
							</Property.Name>
							<Property.Value>
								<FormControl.Static>
									{verb}
								</FormControl.Static>
							</Property.Value>
						</Property>
						<Property>
							<Property.Name>
								{this.intl.formatMsg('Path')}
							</Property.Name>
							<Property.Value>
								<FormControl.Static className="nodeconfig-endpoint-path" title={path}>
									{path}
								</FormControl.Static>
							</Property.Value>
						</Property>
						<Property>
							<Property.Name>
								{this.intl.formatMsg('Status')}
							</Property.Name>
							<Property.Value>
								<FormControl.Static>
									<Status
										tooltipPlacement="bottom"
										// enabled | disabled | error
										type={state}
										tooltip={endpoint.status.error}
									/>
								</FormControl.Static>
							</Property.Value>
						</Property>
						<Description>
							{this.intl.formatMsg('Listens for HTTP API calls to invoke this Flow.')}
						</Description>
					</Panel>
				</Form>
			</div>
		);
	}
}

EndpointConfig.propTypes = {
	/**
	 * The endpoint details.
	 */
	endpoint: PropTypes.object.isRequired
};

export default injectIntl(EndpointConfig);
